import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useToast } from '../hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      if (response.ok) {
        const data = await response.json();
        // Store the JWT token
        localStorage.setItem('adminToken', data.access_token);
        localStorage.setItem('isAdmin', 'true');
        
        toast({
          title: "Login Successful",
          description: "Welcome back, Admin"
        });
        
        setTimeout(() => {
          navigate('/admin/dashboard');
        }, 500);
      } else {
        const errorData = await response.json();
        toast({
          title: "Login Failed",
          description: errorData.detail || "Invalid credentials",
          variant: "destructive"
        });
        setLoading(false);
      }
    } catch (error) {
      toast({
        title: "Login Error",
        description: "Unable to connect to server",
        variant: "destructive"
      });
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 border border-black/20 mb-6">
            <Lock className="w-8 h-8 text-black" strokeWidth={1} />
          </div>
          <h1 
            className="text-4xl font-light mb-4 tracking-wide"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Admin Access
          </h1>
          <div className="h-px w-16 bg-black/20 mx-auto" />
        </div>

        {/* Login form */}
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <Input
              type="text"
              placeholder="Username"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              required
              className="h-14 bg-white border-black/20 focus:border-black transition-colors font-light"
            />
          </div>

          <div>
            <Input
              type="password"
              placeholder="Password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              required
              className="h-14 bg-white border-black/20 focus:border-black transition-colors font-light"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-14 bg-black hover:bg-black/90 text-white font-light tracking-[0.2em] uppercase text-sm transition-all duration-300"
          >
            {loading ? 'Authenticating...' : 'Enter'}
          </Button>
        </form>

        {/* Info */}
        <div className="mt-8 text-center">
          <p className="text-xs tracking-[0.3em] text-black/30 uppercase font-light">
            Authorized Personnel Only
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;